<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img
          class="confectionModal-image img-responsive"
          alt="envelope example"
          :src="image"
          width="350px"
        >
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Personalizacja nadruku na kopercie</h2>
        <section class="confectionModal-descriptions">
          <p>Personalizacja nadruku na kopercie daje Ci możliwość umieszczenia indywidualnej komunikacji dla każdej osoby obdarowanej. W tej sekcji zaznaczysz, jaki format nadruku chcesz zastosować.</p>
        </section>
        <section>
          <p class="font-weight-bold">
            Treść nadruku indywidualnego dodasz przy definiowaniu dostawy w kolejnych krokach.
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'NDEEnvelopeCardPersonalisationModal',
  props: {
    image: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
